import {Component, Inject, Input, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
@Component({
  selector: "app-progress-dialog",
  templateUrl: "./progress-dialog.component.html",
  styleUrls: ["./progress-dialog.component.css"]
})
export class ProgressDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: {message: string}) {}

  ngOnInit() {}

}
